import React from 'react';
import '@ui5/webcomponents-fiori/dist/illustrations/PageNotFound.js';
import '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from 'components/shared/ErrorPage/ErrorPage';

import IllustrationMessageType from '@ui5/webcomponents-fiori/dist/types/IllustrationMessageType.js';

export const DeletedQueryPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      withReturnToMainPageButton
      messageType={IllustrationMessageType.PageNotFound}
      titleText={t('deleted-query-page-title')}
      subtitleText={t('deleted-query-page-subtitle')}
      data-help-id="deleted-query-page"
      data-testid="deleted-query-page"
    />
  );
};
